
import React from 'react';
import { TacticalDeck } from './layout/TacticalDeck';
import { useSal } from '../contexts/SalContext';

export const RouteMap: React.FC = () => {
  const {
    viewMode, setViewMode, setFocusedOrderId, setMapDisplayMode,
    intelligence: { smartSplit, secondsToNextUpdate },
    orders, setOrders, drivers, safeConfig, context, focusedOrderId,
    actions, mapDisplayMode, ui, userProfile
  } = useSal();

  if (viewMode === 'analytics') return null;

  return (
    <TacticalDeck
      viewMode={viewMode} 
      isMapVisible={viewMode === 'map'} 
      onToggleMap={() => { 
        if (viewMode !== 'map') { 
          setFocusedOrderId(null); 
          setMapDisplayMode('tactical'); 
        } 
        setViewMode(prev => prev === 'map' ? 'triage' : 'map'); 
      }}
      smartSplit={smartSplit} 
      orders={orders} 
      drivers={drivers} 
      config={safeConfig} 
      context={context} 
      focusedOrderId={focusedOrderId} 
      onFocusOrder={setFocusedOrderId} 
      heatmapData={[]}
      onOrderLocationUpdate={(id, lat, lng) => setOrders(prev => prev.map(o => o.id === id ? { ...o, lat, lng } : o))}
      onDispatchThirdParty={actions.handleDispatchThirdParty} 
      onApplySequential={() => { }}
      onAcceptWait={actions.handleAcceptWait}
      onManualAssignment={actions.handleManualAssignment}
      onBatchManualAssignment={actions.handleBatchManualAssignment}
      onDispatchCluster={actions.handleDispatchCluster}
      mapDisplayMode={mapDisplayMode}
      setMapDisplayMode={setMapDisplayMode}
      onApplyStrategy={actions.handleApplyStrategy}
      secondsToNextUpdate={secondsToNextUpdate}
      openSofiaDecision={ui?.openSofiaDecision}
      handleConfirmStrategy={actions.handleConfirmStrategy}
      handleConfirmBoomerangStrategy={actions.handleConfirmBoomerangStrategy}
      handleIgnoreStrategy={actions.handleIgnoreStrategy}
      isStrategyIgnored={actions.isStrategyIgnored}
      userRole={userProfile?.role}
    />
  );
};
